import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggingService } from '@pxl/models/contracts';
import { Observable } from 'rxjs';

const noCacheUrls = ['microsoft.com'];

export const noCacheInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const loggingService = inject(LoggingService);
    const url = req.url;

    if (noCacheUrls.some((substr) => url.includes(substr))) {
        const noCacheUrl = url + (url.includes('?') ? '&' : '?') + `_=${Date.now()}`;
        const noCacheReq = req.clone({ url: noCacheUrl });

        loggingService.info('[HTTP] bypass cache for', noCacheUrl);

        return next(noCacheReq);
    }

    return next(req);
};
